import { ActionTypes } from 'redux/utils/List'

export default ActionTypes('DASHBOARD_ASSESSMENT')